// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__PcrZd","icon":"styles_icon__2vKV4","noText":"styles_noText__3NOGR"};